import { Box, Typography, Chip, IconButton, Tooltip, useTheme, useMediaQuery } from '@mui/material';
import { Dashboard as DashboardIcon, TrendingUp, Refresh as RefreshIcon } from '@mui/icons-material';

interface Props {
  todayCount: number;
  isRefreshing: boolean;
  onRefresh: () => void;
}

const DashboardHeader = ({ todayCount, isRefreshing, onRefresh }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between" mb={3} flexWrap="wrap" gap={2}>
      <Box display="flex" alignItems="center" gap={1.5}>
        <Box sx={{
          width: 44, height: 44, borderRadius: '12px',
          background: 'linear-gradient(135deg, #1976d2, #1565c0)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <DashboardIcon sx={{ color: '#fff', fontSize: 24 }} />
        </Box>
        <Box>
          <Typography variant={isMobile ? 'h6' : 'h5'} fontWeight={800} sx={{ letterSpacing: '-1px', color: '#0f172a' }}>
            대시보드
          </Typography>
          <Typography variant="caption" color="text.secondary">
            실시간 매입 현황과 통계
          </Typography>
        </Box>
      </Box>

      <Box display="flex" alignItems="center" gap={1}>
        <Chip
          icon={<TrendingUp sx={{ fontSize: 16 }} />}
          label={`오늘 ${todayCount}건`}
          size="small"
          sx={{
            fontWeight: 700,
            bgcolor: '#eff6ff',
            color: '#1976d2',
            border: '1px solid #bfdbfe',
            '& .MuiChip-icon': { color: '#1976d2' },
          }}
        />
        <Tooltip title="새로고침">
          <IconButton
            onClick={onRefresh}
            disabled={isRefreshing}
            size="small"
            sx={{
              bgcolor: '#f1f5f9',
              '&:hover': { bgcolor: '#e2e8f0', transform: 'rotate(180deg)' },
              transition: 'all 0.3s ease',
            }}
          >
            <RefreshIcon sx={{ fontSize: 20 }} className={isRefreshing ? 'rotating' : ''} />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default DashboardHeader;
